"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.routes = void 0;
const types_1 = require("./types");
exports.routes = (0, types_1.buildRoutes)({
    workflowDefinition: {
        path: "/workflows/:workflowDefinitionId/overview",
    },
    listWorkflows: {
        path: "/workflows/:workflowDefinitionId",
    },
    workflow: {
        path: "/workflow/:workflowId",
    },
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoid29ya2Zsb3dzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vcm91dGluZy93b3JrZmxvd3MudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsbUNBQXNDO0FBRXpCLFFBQUEsTUFBTSxHQUFHLElBQUEsbUJBQVcsRUFBQztJQUNoQyxrQkFBa0IsRUFBRTtRQUNsQixJQUFJLEVBQUUsMkNBQTJDO0tBQ2xEO0lBQ0QsYUFBYSxFQUFFO1FBQ2IsSUFBSSxFQUFFLGtDQUFrQztLQUN6QztJQUNELFFBQVEsRUFBRTtRQUNSLElBQUksRUFBRSx1QkFBdUI7S0FDOUI7Q0FDRixDQUFDLENBQUMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBidWlsZFJvdXRlcyB9IGZyb20gXCIuL3R5cGVzXCI7XG5cbmV4cG9ydCBjb25zdCByb3V0ZXMgPSBidWlsZFJvdXRlcyh7XG4gIHdvcmtmbG93RGVmaW5pdGlvbjoge1xuICAgIHBhdGg6IFwiL3dvcmtmbG93cy86d29ya2Zsb3dEZWZpbml0aW9uSWQvb3ZlcnZpZXdcIixcbiAgfSxcbiAgbGlzdFdvcmtmbG93czoge1xuICAgIHBhdGg6IFwiL3dvcmtmbG93cy86d29ya2Zsb3dEZWZpbml0aW9uSWRcIixcbiAgfSxcbiAgd29ya2Zsb3c6IHtcbiAgICBwYXRoOiBcIi93b3JrZmxvdy86d29ya2Zsb3dJZFwiLFxuICB9LFxufSk7XG4iXX0=